export default __webpack_public_path__ + "images/8N.1ca3fb4.png";